/**
 * A trivial component to render svgs in the aside slot. This is needed because
 * @gonfalon/react's useSlots function requires a component to match the slot,
 * and we can't use a primitive like <span> directly in the BaseEmptyState.
 */
export function EmptyStateAside({ children }: { children: React.ReactNode }) {
  return <span slot="aside">{children}</span>;
}
